/* import __COLOCATED_TEMPLATE__ from './seller-profile-details-compact.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { scheduleOnce } from '@ember/runloop';
import { inject as service } from '@ember/service';
import {
  PROFILE_SUB_SECTION_STATES,
  PROFILE_OVERLAY_SCROLL_VIEW_CLASS,
  SELLER_PROFILE__REVIEWS_BACKGROUND_CLASS,
} from 'sh-www/constants/components/profile';
import { stopClickEvent } from 'sh-www/utils/events';
import clsx from 'clsx';

const CLASS_NAME = 'SH-c-seller-profile-details-compact';

class SellerProfileDetailsCompact extends Component {
  /**
   * Register services
   */
  @service('states/application') applicationState;
  @service('state-managers/application') applicationStateManager;
  @service session;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  /**
   * @type {Boolean}    True if we want to show the smaller image for mobile views.
   */
  isShowSmallImage() {
    return this.media.isMediumAndDown;
  }

  @action
  async onReviewCountClicked(event) {
    stopClickEvent(event);

    // swap to profile tab before scrolling to reviews
    await this.args.updateProfileSubSection(PROFILE_SUB_SECTION_STATES.SUB_SECTION_PROFILE)

    scheduleOnce('afterRender', this, () => {
      const profileOverlayScrollViewEl = document.querySelector(`.${PROFILE_OVERLAY_SCROLL_VIEW_CLASS}`);
      const reviewsEl = document.querySelector(`.${SELLER_PROFILE__REVIEWS_BACKGROUND_CLASS}`);

      if (profileOverlayScrollViewEl) {
        const scrollTop = reviewsEl.getBoundingClientRect().top + profileOverlayScrollViewEl.scrollTop;
        profileOverlayScrollViewEl.scrollTo({ top: scrollTop, behavior: 'smooth' });
      } else {
        const scrollTop = reviewsEl.getBoundingClientRect().top + window.scrollY - 70;
        window.scrollTo({ top: scrollTop, behavior: 'smooth' });
      }
    });
  }

  @action
  async handleEmailClick() {
    try {
      await navigator.clipboard.writeText(this.args.user.email);
      this.applicationStateManager.addToast('Email copied to clipboard');
    } catch (e) {
      this.applicationStateManager.addToast('Failed to copy email')
    }
  }
}

export default SellerProfileDetailsCompact;
